<div class="wrapper wrapper-content animated fadeInRight">
<div data-cy="tournaments-list">
  <app-import-modal
    (importConfirmed)="onImportConfirmed($event)"
  ></app-import-modal>

  <!-- Shared Search Input -->
  <div class="search-row">
    <div class="input-group">
      <input
        type="text"
        placeholder="Search for Tournaments by Name, Location, or Number"
        class="input form-control"
        [ngModel]="searchText()"
        (ngModelChange)="searchText.set($event)"
        data-cy="search-input"
      />
      <span class="input-group-btn">
        <button type="button" class="btn btn-primary" data-cy="search-button">
          <i class="fa fa-search"></i> Search
        </button>
        <button
          type="button"
          class="btn btn-secondary"
          (click)="clearSearch()"
          data-cy="clear-button"
          title="Clear search"
        >
          <i class="fa fa-times"></i>
        </button>
      </span>
    </div>
  </div>

  <div class="ibox-content">
    <div class="clients-list">
      <ul class="nav nav-tabs" role="tablist">
        <li [class.active]="activeTab() === 'local'">
          <a role="tab"
             [attr.aria-selected]="activeTab() === 'local'"
             href="javascript:void(0)"
             (click)="setActiveTab('local')"
            ><i class="fa fa-user"></i> Local System ({{
              filteredTournaments().length
            }})</a
          >
        </li>
        <li [class.active]="activeTab() === 'import'">
          <a role="tab"
             [attr.aria-selected]="activeTab() === 'import'"
             href="javascript:void(0)"
             (click)="setActiveTab('import')"
            ><i class="fa fa-briefcase"></i> Import from HQ ({{
              filteredSourceTournaments().length
            }})</a
          >
        </li>
        <button
          title="Create a New Blank Tournament"
          class="btn btn-success float-right ml-auto header-action"
          (click)="importEmptyTournament()"
        >
          <i class="fa fa-download"></i> Create Blank
        </button>
      </ul>
      <div class="tab-content">
        @if (activeTab() === 'local') {
        <div class="tab-pane active">
          <div class="full-height-scroll">
            <app-tournament-list
              [tournaments]="tournaments()"
              [filteredTournaments]="filteredTournaments()"
              (toggleTournamentStatus)="toggleTournamentStatus($event)"
              (viewTournament)="viewTournament($event)"
              (exportTournaments)="exportLocalTournaments()"
            ></app-tournament-list>
          </div>
        </div>
        }
        @if (activeTab() === 'import') {
        <div class="tab-pane active">
          <div class="full-height-scroll">
            <app-tournament-import-list
              [sourceTournaments]="sourceTournaments()"
              [filteredSourceTournaments]="filteredSourceTournaments()"
              (openImportModal)="openImportModal($event)"
              (exportSourceTournaments)="exportSourceTournaments()"
            ></app-tournament-import-list>
          </div>
        </div>
        }
      </div>
    </div>
  </div>
</div>
</div>
